import React, { useEffect, useState } from "react";
import PendingInvoices from "./PendingInvoices";
import PendingCredits from "./PastInvoices";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PastInvoices from "./PastInvoices";
import { useTranslation } from "react-i18next";
import { getUpdatedSchool } from "../../../../components/CommonApis";
import Util from "../../../../Util";
import Loader from "../../../../components/common/Loader";

export default function PendingTab() {
  const [value, setValue] = useState("1");
  const { t } = useTranslation();
  const school = Util.getSelectedSchool();
  const [schoolLoading, setSchoolLoading] = useState(true);
  const [isSchool, setIsSchool] = useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    async function fetchData() {
      const schooldata = await getUpdatedSchool(school.id);
      setIsSchool(schooldata);
      setSchoolLoading(false);
    }

    fetchData();
  }, [school.id]);

  if (schoolLoading) {
    return <Loader />;
  }

  if (!isSchool?.billing) {
    return (
      <div
        className="d-flex justify-content-center"
        style={{
          fontWeight: "bold",
          fontSize: "20px",
          color: "#ed3131",
          alignItems: "center",
          height: "500px",
        }}
      >
        Module Access Denied
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="body">
        <div className="col-lg col-md-12 p-3">
          <div className="row py-3">
            <div className="col-md-8">
              <h2 className="page-head">{t("Pending Invoices & Credits")}</h2>
            </div>
            <div className="col-md-8"></div>
          </div>
          <Box sx={{ width: "100%" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="secondary"
              indicatorColor="secondary"
              aria-label="secondary tabs example"
              sx={{
                "& .MuiTabs-indicator": {
                  backgroundColor: "#6418c3",
                  height: 2,
                },
              }}
            >
              <Tab
                sx={{
                  "&.Mui-selected": {
                    color: "#6418c3",
                    fontWeight: "600",
                  },
                }}
                value="1"
                label={t("Pending Invoices")}
              />
              <Tab
                sx={{
                  "&.Mui-selected": {
                    color: "#6418c3",
                    fontWeight: "600",
                  },
                }}
                value="2"
                label={t("Paid Invoices")}
              />
            </Tabs>
          </Box>
          {value === "1" && <PendingInvoices />}
          {value === "2" && <PastInvoices />}
        </div>
      </div>
    </div>
  );
}
